import axios from '../axios';
const apiPath = 'api/admin/consume-settings';

const consumeSettingApi = {
    show: () => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/show/1`
        );
    },
    update: entity => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/update/1`,
            {
                ...entity
            }
        );
    }
};

export default consumeSettingApi;
